import { gql } from '@apollo/client';
import { REPLY_FRAGMENT } from './reply-fragments';

export const CREATE_REPLY = gql`
    mutation createReply($reviewId: ID!, $text: String!) {
        createReply(reviewId: $reviewId, text: $text) {
            ...ReplyFragment
        }
    }
    ${REPLY_FRAGMENT}
`;

export const REMOVE_REPLY = gql`
    mutation removeReply($id: ID!) {
        removeReply(id: $id) {
            id
        }
    }
`;
